import { SessionService } from './../../../../../core/session/session.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EnvironmentService } from '@app/core/environment/environment.service';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Menu } from '@app/shared/menu/menu.model';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuPermissionService {

  private serviceUrl: string = '/users/menus';
  private apiUrl: string;
  private iServicesUri: string;

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService,
    private sessionService: SessionService,
  ) {
    this.apiUrl = this.environmentService.envModel.appSettings.apiUrlMenu;
    this.iServicesUri = this.environmentService.envModel.appSettings.fm6ApiUrlFeatureToggle;
  }


  getMenus(token: String): Observable<Menu[]> {
    const url = `${this.apiUrl}${this.serviceUrl}/${token}`;
    return this.http.get<Menu[]>(url).pipe(
      catchError(this.handleError),
      map(this.jsonDataToMenus)
    );
  }

  jsonDataToMenus(jsonData: any[]): Menu[] {
    const menus: Menu[] = [];
    if (jsonData && Array.isArray(jsonData)) {
      jsonData.forEach(element => menus.push(element as Menu));
    }
    return menus;
  }

  handleError(error: any): Observable<any> {
    return throwError(error);
  }

  getMenusiService(businessId: String, gestor: String): Observable<any> {
    const jwt = this.sessionService.retrieveToken();
    const headers = new HttpHeaders({Authorization: `Bearer ${jwt}`});
    const url = `${this.iServicesUri}/regras-prime/gestores/${gestor}/usuarios/${businessId}`;

    return this.http.get<any>(url, { headers });
  }
}
